import { render } from "./MenuItem.vue?vue&type=template&id=06cb4543&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=06cb4543&scoped=true&lang=css"
import "./MenuItem.vue?vue&type=style&index=1&id=06cb4543&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cb4543"]])

export default __exports__